import React, { useState, useEffect } from 'react';
import { SEO, Hero } from '../components/Shared';

const steps = [
  { time: '0-5 min', title: 'Tunnistus ja Eristys', detail: 'Katkaise verkkoyhteys välittömästi (Wi-Fi pois, kaapeli irti). ÄLÄ sammuta laitetta, jotta RAM-muistin tiedot ja haittaohjelman jäljet säilyvät tutkimuksia varten.' },
  { time: '5-15 min', title: 'Hälytys', detail: 'Ilmoita organisaation tietoturvavastaavalle tai IT-tukeen. Käytä varakanavaa (Signal/Puhelu), jos sähköposti tai Slack on vaarantunut.' },
  { time: '15-30 min', title: 'Vahinkojen kartoitus', detail: 'Mitä dataa on uhattuna? Onko asiakasrekisteri tai lähdekoodi vaarantunut? Kirjaa havainnot ylös paperille tai erilliseen laitteeseen.' },
  { time: '30-60 min', title: 'Eskalointi ja Viestintä', detail: 'Valmistele ilmoitus tietosuojavaltuutetulle (GDPR 72h). Määrittele sidosryhmät, joille on tiedotettava, ja valmistele viestintä.' }
];

const CrisisProtocol: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [timer, setTimer] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval: any;
    if (isRunning) {
      interval = setInterval(() => setTimer(t => t + 1), 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning]);

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-20">
      <SEO title="Kriisiprotokolla 0-60 min | Lapland AI Lab" description="Välitön toimintaohje tietomurron sattuessa." />
      <Hero title="Kriisiprotokolla" subtitle="Seuraa näitä askelia välittömästi. Aika on kriittinen tekijä vahinkojen minimoinnissa." label="Simulated Incident Protocol" />
      
      <div className="mb-10 p-5 bg-amber-500/10 border border-amber-500/30 rounded-2xl text-xs text-amber-400 font-bold uppercase tracking-widest text-center">
        ⚠️ Harjoitusskenaario – ei reaaliaikaista valvontaa tai ulkoista reagointipalvelua.
      </div>

      <div className="glass p-10 rounded-[3rem] border-red-500/20 mb-12 shadow-[0_0_50px_rgba(239,68,68,0.1)]">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12 gap-6">
          <div className="text-center md:text-left">
            <span className="text-xs font-black text-red-400 uppercase tracking-widest block mb-2">Simuloitu Kriisiaika</span>
            <span className="text-5xl font-black text-white font-mono">{formatTime(timer)}</span>
          </div>
          <button 
            onClick={() => setIsRunning(!isRunning)}
            className={`px-10 py-5 rounded-2xl font-black uppercase tracking-widest transition-all ${isRunning ? 'bg-slate-800 text-red-500' : 'bg-red-500 text-slate-950 shadow-xl shadow-red-500/30 active:scale-95'}`}
          >
            {isRunning ? 'Pysäytä kello' : 'Aloita harjoitus'}
          </button>
        </div>

        <div className="space-y-6">
          {steps.map((step, idx) => (
            <div 
              key={idx}
              onClick={() => setActiveStep(idx)}
              className={`p-8 rounded-3xl border transition-all cursor-pointer ${activeStep === idx ? 'bg-red-500/10 border-red-500/40 shadow-lg' : 'bg-slate-900/50 border-slate-800 opacity-50 hover:opacity-100'}`}
            >
              <div className="flex justify-between items-center mb-4">
                <span className="text-[10px] font-black text-red-400 uppercase tracking-[0.3em]">{step.time}</span>
                {activeStep === idx && <span className="w-2 h-2 bg-red-500 rounded-full animate-ping"></span>}
              </div>
              <h3 className="text-xl font-black text-white mb-2">{step.title}</h3>
              {activeStep === idx && <p className="text-slate-400 leading-relaxed text-sm">{step.detail}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CrisisProtocol;
